/**
 * Bot Framework Web Chat style options for the Copilot panel.
 * @see https://github.com/microsoft/BotFramework-WebChat#styling
 */

export const copilotWebChatStyleOptions = {
  accent: '#0078D4',
  backgroundColor: 'transparent',
  bubbleBackground: '#FFFFFF',
  bubbleBorderColor: '#E2E8F0',
  bubbleBorderRadius: 12,
  bubbleFromUserBackground: '#F1F5F9',
  bubbleFromUserBorderColor: '#E2E8F0',
  bubbleFromUserBorderRadius: 12,
  bubbleFromUserTextColor: '#0F172A',
  bubbleTextColor: '#334155',
  primaryFont:
    '"Segoe UI", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  sendBoxBackground: '#FFFFFF',
  sendBoxBorderTop: '1px solid rgba(168, 85, 247, 0.08)',
  sendBoxButtonColor: '#0078D4',
  sendBoxTextColor: '#0F172A',
  sendBoxHeight: 68,
  disableFileUpload: true,
  timestampColor: '#94A3B8',
  typingAnimationHeight: 0,
  typingAnimationWidth: 0,
  // Hide dashed focus ring when clicking transcript / activity areas
  transcriptActivityVisualKeyboardIndicatorWidth: 0,
  transcriptVisualKeyboardIndicatorWidth: 0,
} as const;

export default copilotWebChatStyleOptions;
